import { render, staticRenderFns } from "./textFile.vue?vue&type=template&id=6923d36a&scoped=true&"
import script from "./textFile.vue?vue&type=script&lang=js&"
export * from "./textFile.vue?vue&type=script&lang=js&"
import style0 from "./textFile.vue?vue&type=style&index=0&id=6923d36a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6923d36a",
  null
  
)

export default component.exports